import React, { useEffect, useState } from "react";
import "../styles/Thankyou.scss";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "../helpers/functions";
import { config } from "../config/config";
import { getPaymentLink } from "../api/InvoiceApi";
import Button from "../components/Button";
import { useHistory } from "react-router";
import c from "../helpers/constants";


const PayByLink = () => {
  const query = useQuery();
  const [paid, setPaid] = useState(false);
  const history = useHistory();
  
  useEffect(() => {
    const handlePaymentLink = async () => {
      let p = {
        data: query.get("data") || "",
      };


    
      
      
      if (p.data == "") {
        const baseURL = `${window.location.protocol}//${
          window.location.hostname
        }${window.location.port ? `:${window.location.port}` : ""}`;
        window.location.href = baseURL;
        return;
      }

      const link = await getPaymentLink(p.data);

      if(link.hasOwnProperty('price_changed')){
        history.push(c.APP_ROUTES.PRICE_CHANGED);
        return;
      }

      if ( !link.hasOwnProperty('paid') && link.hasOwnProperty("paymentLink")) {
        setTimeout(() => {
          window.location.href = link.paymentLink;
        }, 3000);
      }

      if( link.hasOwnProperty('paid') ){
        setPaid(true);
      }
    };

    handlePaymentLink();
  }, []);

  const goToLogin = () => {
    history.push(c.APP_ROUTES.LOGIN);
  };
  return (
    <div className="thankyou">
      <div className="container">
        <div className="thankyou-header text-white">
          <span className="ml-2">&nbsp;</span>
        </div>

        <div className="thankyou-card">
          <div className="thankyou-card-header">
            <div className="paybylink-branding">
              <img
                src={config.likewiseLogo}
                className="navbar-brand"
                alt={config.companyName + " Logo"}
              />
            </div>

            <div className="anti-fraud mb-4 mt-4">
              {config.payit.antiFraudMessage}
            </div>

    {!paid && (
            <div className="">
              <div className="">
                <p>
                  You will now be redirected to your bank to complete your
                  payment.
                </p>
              </div>
              <div className="the-loader">
                <div className="loader"></div>
              </div>
            </div>
            )}

            {
              paid && (
                <div className="paid-message">
                  <p>
                    You have already paid for this invoice. Please login to your account to view your account.
                  </p>
                  <Button onClick={goToLogin} text="Go to Login" />
                </div>
              )
            }

            <div className="payit-branding">
              <img src={config.payitBrand} alt="payit brand" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayByLink;
